import { render, staticRenderFns } from "./PreviousEdition.vue?vue&type=template&id=7b25310b&scoped=true"
import script from "./PreviousEdition.vue?vue&type=script&lang=js"
export * from "./PreviousEdition.vue?vue&type=script&lang=js"
import style0 from "./PreviousEdition.vue?vue&type=style&index=0&id=7b25310b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b25310b",
  null
  
)

export default component.exports